import React, { useState, useEffect } from 'react';
import ImageGallery from '@/components/ImageGallery';

function ImageReviewLensRemoved() {
  const [uploadConfig] = useState({
    imageKind: "lens-removed",
    directory: "lens-removed"
  });
  return (
    <ImageGallery
      imageKind={uploadConfig.imageKind}
      directory={uploadConfig.directory}
   />
  );
};

export default ImageReviewLensRemoved;